import { DateTime } from 'luxon';
import * as yup from 'yup';

export type SchedulesValidationSchemaAttrs = {
  adsFreeTrialConfig?: {
    durationWeeks: number;
  };
};

export const schedulesValidationSchema = ({ adsFreeTrialConfig }: SchedulesValidationSchemaAttrs) =>
  yup.object({
    startDate: yup
      .string()
      .test({
        name: 'startDate',
        message: 'campaigns.form.scheduling.schedules.errors.start-date-too-late',
        test: (value: string, context: yup.TestContext) => {
          if (!context.parent.endDate || context.parent.scheduleStrategy === 'alwaysOn') {
            return true;
          }
          const endDate = DateTime.fromISO(context.parent.endDate).set({
            hour: 11,
            minute: 59,
            second: 59,
            millisecond: 0,
          });
          const startDate = DateTime.fromISO(value).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
          return startDate <= endDate;
        },
      })
      .required('campaigns.ads.schedule.start-date-required'),
    endDate: yup.string().test({
      name: 'endDate',
      message: 'campaigns.ads.free-trials.campaign-duration-error',
      test: (value: string, context: yup.TestContext) => {
        if (!context.parent.endDate || context.parent.scheduleStrategy === 'alwaysOn') {
          return true;
        }

        const isFreeTrialDisabled = !adsFreeTrialConfig || context.parent.isFreeTrial === false;
        if (isFreeTrialDisabled) {
          return true;
        }

        const freeTrialDays = DateTime.fromISO(context.parent.startDate).plus({
          weeks: adsFreeTrialConfig?.durationWeeks || 0,
        });
        const adFreeTrialMinimumEndDate = freeTrialDays.minus({ days: 2 });
        const endDate = DateTime.fromISO(value);

        // Backend can't create campaigns with 1 day duration,
        // so the extra campaign is 1 days of duration it should invalid
        if (endDate.hasSame(adFreeTrialMinimumEndDate.plus({ days: 2 }), 'day')) {
          return false;
        }

        return endDate >= adFreeTrialMinimumEndDate;
      },
    }),
    scheduleStrategy: yup.mixed().oneOf(['alwaysOn', 'selectDates']).required(),
  });
